import React from 'react';
import { motion } from 'framer-motion';
export function FieldNote() {
  return <section className="border-y border-border bg-card" data-id="element-10">
      <div className="container py-8 md:py-10" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row md:items-start gap-4 md:gap-8" data-id="element-12">
          <div className="flex items-center gap-2 shrink-0 border border-signal/30 bg-signal/10 px-3 py-1.5" data-id="element-13">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-signal animate-signal-pulse" aria-hidden="true" data-id="element-14" />
            <span className="font-mono text-xs tracking-widest uppercase text-signal" data-id="element-15">
              From the field
            </span>
          </div>
          <p className="font-heading text-lg md:text-xl text-foreground leading-relaxed max-w-3xl" data-id="element-16">
            Week 3, logistics client: the model has been routing live orders
            since Tuesday. Dispatch stopped double-checking it on Thursday.{' '}
            <span className="text-muted-foreground" data-id="element-17">
              The write-up can wait.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}